import { Box, styled } from "@mui/material";

export const DeleteBlockOffModalStyled = styled(Box)`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  .btn-wrapper {
    display: flex;
    column-gap: 8px;
    align-self: flex-end;
  }
`;
